

































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import PickWave from "../../../store/entities/pick-wave";
import PickWaveObject from "../../../store/entities/pick-wave-object";
import PickList from "../../../store/entities/pick-list";
import AppConsts from "@/lib/appconst";
import breadcrumbNavVue from "../../../components/breadcrumb-nav.vue";
import _ from "lodash";
import PackWaveObject from "../../../store/entities/pick-wave-object";
import SoStatus from "../../../store/entities/soStatus";
import Customer from "@/store/entities/customers/customer";
import expandRow from "./selected-object-expand.vue";
import * as moment from "moment";

class PageSearchObjectRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  refTypeCode: string;
  //provinceCode : string;
  agingDays: number = 0;
  from: Date;
  to: Date;
  status: string;
  customerId: number;
  isAoGroup: boolean;
}

@Component({
  components: { expandRow },
})
export default class CreatePickWave extends AbpBase {
  //filters
  pagerequest: PageSearchObjectRequest = new PageSearchObjectRequest();
  step: number = 0;
  pickWaveId: number = 0;
  isAllocating: Boolean = false;
  isSelectingObject: Boolean = false;
  isCreatingPicklist: Boolean = false;
  isInitingPickwave: Boolean = false;
  pickWave: PickWave = new PickWave();

  selectedObjects: Array<PickWaveObject> = new Array<PickWaveObject>();

  allocatedFaObjects: Array<PickWaveObject> = new Array<PickWaveObject>();
  allocatedPaObjects: Array<PickWaveObject> = new Array<PickWaveObject>();
  numFaObjectSingle: number = 0;
  numFaObjectMutilple: number = 0;
  numFaObjectOversize: number = 0;
  canCancelPw: boolean = false;

  pickLists: Array<PickList> = new Array<PickList>();
  numOfPl: number = 0;

  pickWaveType: string = "";
  inputNumOfSio: number = 0;
  inputNumOfMio: number = 0;
  inputNumOfPto: number = 0;
  inputNumPlOfSo: number = 0;
  isPto: boolean = true;
  isStandard: boolean = false;
  strGuessPwPtoAndTransport: string = "";
  strGuessPwSioAndTransport: string = "";
  strGuessPwMioAndTransport: string = "";

  soDates: Date[] = [];

  list: PackWaveObject[] = new Array<PackWaveObject>();
  soStatuses: SoStatus[] = new Array<SoStatus>();

  customerLoading: boolean = false;
  customers: Array<Customer> = new Array<Customer>();
  customer: Customer = new Customer();
  arrayBinAllocate: string = "";
  refTypes = [];
  clients = [];

  create() {}

  //=========================================================
  //control step

  activeStep(next: boolean, step: any) {
    if (step != undefined) {
      this.step = step;
    } else {
      if (next && this.step < 3) {
        this.step++;
      }
      if (!next && this.step > 0) {
        this.step--;
      }
    }
  }

  nextStep() {
    this.activeStep(true, undefined);
  }

  backStep() {
    this.activeStep(false, undefined);
  }

  //=========================================================
  //Step 0: Create Empty Pick Wave
  createEmptyPickWave() {
    this.isInitingPickwave = true;
    this.$store
      .dispatch("pickwaveCreated/create", {})
      .then((res) => {
        this.isInitingPickwave = false;
        this.activeStep(true, undefined);
        this.step == res.step;
        this.pickWaveId = res.id;
        this.pickWave.id = res.id;
        this.pickWave.code = res.code;
        this.pickWave.status = res.textStatus;
        this.pickWave.refTypeCode = res.refTypeCode;
        this.pickWave.refTypeName = res.refTypeName;
      })
      .catch(() => {
        this.isInitingPickwave = false;
      });
  }

  //=========================================================
  //Check Work Order
  checkWorkOrder() {
    this.isInitingPickwave = true;
    this.$store
      .dispatch("pickwaveCreated/checkWorkOrder", {})
      .then((res) => {
        this.isInitingPickwave = false;
        this.activeStep(true, res.step);
        this.pickWaveId = res.id;
        this.pickWave.id = res.id;
        this.pickWave.code = res.code;
        this.pickWave.status = res.textStatus;
        this.pickWave.refTypeCode = res.refTypeCode;
        this.pickWave.refTypeName = res.refTypeName;
        switch (res.step) {
          case 1:
            this.selectedObjects = res.objectSelected;
            break;
          case 2:
            this.allocatedFaObjects = res.pickWaveAllocated.faObjects;
            this.allocatedPaObjects = res.pickWaveAllocated.paObjects;
            this.numFaObjectSingle = res.pickWaveAllocated.numFaObjectSingle;
            this.numFaObjectMutilple =
              res.pickWaveAllocated.numFaObjectMutilple;
            this.numFaObjectOversize =
              res.pickWaveAllocated.numFaObjectOversize;
            this.canCancelPw = res.pickWaveAllocated.canCancel;
            this.onLoadDefaultGuessStepThree();
            break;
        }
      })
      .catch(() => {
        this.isInitingPickwave = false;
      });
  }

  //=========================================================
  // Step 1 : Select Object
  getRefTypes() {
    var re = this.$store.state.ref.refTypesForSelect;
    re = _.filter(re, (v) => _.includes(AppConsts.refTypeForPickWave, v.code));
    re.forEach((element) => {
      element.description = this.L(
        `${AppConsts.prefixConsts.ref}${element.code}`
      );
    });
    this.refTypes = re;
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        this.pagerequest.clientCode =
          this.clients.length === 0 ? "" : this.clients[0].code;
      });
  }

  getList() {
    var re = this.$store.state.pickwaveCreated.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    this.list = re;
  }

  get loading() {
    return this.$store.state.pickwaveCreated.loading;
  }

  pageChange(page: number) {
    this.$store.commit("pickwaveCreated/setCurrentPage", page);
    this.searchObjects();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("pickwaveCreated/setPageSize", pagesize);
    this.searchObjects();
  }

  async searchObjects() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    if (this.soDates.length > 0) {
      this.pagerequest.from = this.soDates[0];
    }
    if (this.soDates.length > 1) {
      this.pagerequest.to = this.soDates[1];
    }

    await this.$store
      .dispatch({
        type: "pickwaveCreated/searchObjects",
        data: this.pagerequest,
      })
      .then((res) => {
        this.getList();
      });
  }
  get pageSize() {
    return this.$store.state.pickwaveCreated.pageSize;
  }
  get totalCount() {
    return this.$store.state.pickwaveCreated.totalCount;
  }
  get currentPage() {
    return this.$store.state.pickwaveCreated.currentPage;
  }

  columnSearchObjects = [
    {
      type: "expand",
      width: 50,
      fixed: "left",
      render: (h, params) => {
        return h(expandRow, {
          props: {
            row: params.row,
          },
        });
      },
    },
    {
      title: this.L("SoRequestCode"),
      width: 150,
      fixed: "left",
      slot: "slotSoRequestCode",
    },
    {
      title: this.L("SoCode"),
      width: 150,
      slot: "slotExternalSoCode",
    },
    {
      title: this.L("AoGroup"),
      width: 150,
      slot: "slotAoGroup",
    },
    {
      title: this.L("Status"),
      width: 100,
      key: "textStatus",
    },
    {
      title: this.L("Customer"),
      width: 150,
      key: "formatCustomer",
    },
    {
      title: this.L("ShippingAddress"),
      width: 150,
      key: "shippingAddress",
    },
    {
      title: this.L("AgingDay"),
      width: 100,
      align: "right",
      key: "agingDays",
    },
    {
      title: this.L("Client"),
      width: 150,
      key: "clientName",
    },

    {
      type: "selection",
      width: 50,
      fixed: "right",
      align: "center",
    },
  ];

  confirmSelectObjects() {
    var objectIds = [];
    _.forEach(this.list, (item) => {
      if (item.isSelected === true) {
        objectIds.push(item.id);
      }
    });
    if (objectIds.length == 0) {
      this.showErrorMsg(this.L("YouHaveNotYetChoicedSaleOrder"));
      return;
    }

    this.$Modal.confirm({
      title: this.L("PwSelectObjectComfirm"),
      content: "",
      okText: Util.getYesText(),
      cancelText: Util.getNoText(),
      onOk: async () => {
        this.doSelectObjects(objectIds);
      },
    });
  }
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.customerLoading = false;
  }

  doSelectObjects(objectIds) {
    var param = {
      objectIds: objectIds,
    };
    this.isSelectingObject = true;
    this.$store
      .dispatch("pickwaveCreated/PushObject", param)
      .then((res) => {
        this.isSelectingObject = false;
        this.pickWave.refTypeCode = this.pagerequest.refTypeCode;
        this.pickWave.refTypeName = Util.L(`TOItemTypeSO`);
        _.forEach(res.items, (item) => {
          this.selectedObjects.push(item);
        });
        this.searchObjects();

        if (res.warningMessage != "") {
          this.showWraningMsg(res.warningMessage);
        }
      })
      .catch(() => {
        this.isSelectingObject = false;
      });
  }

  onSelect(selection, row) {
    this.$emit("on-select", selection, row);
  }
  onSelectCancel(selection, row) {
    this.$emit("on-select-cancel", selection, row);
  }
  onSelectAll(selection) {
    this.$emit("on-select-all", selection);
  }
  onSelectionChange(selection) {
    this.$emit("on-selection-change", selection);
    _.forEach(this.list, (o) => {
      var itemSelected = _.find(selection, function(x) {
        return x.id === o.id;
      });
      if (itemSelected) {
        o.isSelected = true;
      } else {
        o.isSelected = false;
      }
    });
  }

  pageChangeSelectedObject(page: number) {
    this.$store.commit("pickwaveCreated/setCurrentPageSelectedObject", page);
    this.searchObjects();
  }

  pagesizeChangeSelectedObject(pagesize: number) {
    this.$store.commit("pickwaveCreated/setPageSizeSelectedObject", pagesize);
    this.searchObjects();
  }

  get pageSizeSelectedObject() {
    return this.$store.state.pickwaveCreated.pageSizeSelectedObject;
  }
  get totalCountSelectedObject() {
    return this.$store.state.pickwaveCreated.totalCountSelectedObject;
  }
  get currentPageSelectedObject() {
    return this.$store.state.pickwaveCreated.currentPageSelectedObject;
  }

  columnSelectedObjects = [
    {
      title: this.L("SoRequestCode"),
      width: 150,
      fixed: "left",
      key: "externalSoRequestCode",
    },
    {
      title: this.L("SoCode"),
      width: 150,
      key: "externalCode",
    },
    {
      title: this.L("Status"),
      width: 100,
      key: "textStatus",
    },
    {
      title: this.L("Customer"),
      width: 150,
      key: "formatCustomer",
    },
    {
      title: this.L("ShippingName"),
      width: 150,
      key: "shippingName",
    },
    {
      title: this.L("ShippingAddress"),
      width: 150,
      key: "shippingAddress",
    },
    {
      title: this.L("ExpectedDeliveryDate"),
      width: 150,
      key: "expectedDeliveryDate",
      render: (h: any, params: any) => {
        return h(
          "span",
          Util.toViewDateString(params.row.expectedDeliveryDate)
        );
      },
    },
    {
      title: this.L("AgingDay"),
      width: 100,
      align: "right",
      key: "agingDays",
    },
    {
      title: this.L("Client"),
      width: 150,
      key: "clientName",
    },
    {
      title: this.L("AoGroup"),
      width: 150,
      key: "aoGroupCode",
    },
    {
      title: this.L("Action"),
      key: "Actions",
      width: 100,
      fixed: "right",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("PwRevertSelectedObjectComfirm"),
                    content: this.L("PwDoYouWantToRevertSelectedObject"),
                    okText: Util.getYesText(),
                    cancelText: Util.getNoText(),
                    onOk: async () => {
                      await this.doRevertObject(params.row);
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];

  doRevertObject(item) {
    var param = {
      objectId: item.id,
    };

    this.$store.dispatch("pickwaveCreated/RevertObject", param).then((res) => {
      this.selectedObjects.splice(item._index, 1);
      this.searchObjects();
    });
  }

  allocateItems() {
    this.isAllocating = true;
    this.$store
      .dispatch("pickwaveCreated/AllocateItems", {
        arrayBin: this.arrayBinAllocate,
      })
      .then((res) => {
        this.isAllocating = false;
        this.step++;
        this.allocatedFaObjects = res.faObjects;
        this.allocatedPaObjects = res.paObjects;
        this.numFaObjectSingle = res.numFaObjectSingle;
        this.numFaObjectMutilple = res.numFaObjectMutilple;
        this.numFaObjectOversize = res.numFaObjectOversize;
        this.canCancelPw = res.canCancel;
        this.onLoadDefaultGuessStepThree();
        if (res.warningMessage != "") {
          this.showWraningMsg(res.warningMessage);
        }
      })
      .catch(() => {
        this.isAllocating = false;
      });
  }

  //=========================================================
  //Step 3 Allocate Object - Items

  columnAllocatedFaObjects = [
    {
      title: this.L("Code"),
      key: "code",
      fixed: "left",
    },
    {
      title: this.L("ExternalCode"),
      key: "externalCode",
    },
    {
      title: this.L("Client"),
      key: "clientName",
    },
    {
      title: this.L("Status"),
      key: "textStatus",
    },
    {
      title: this.L("AgingDay"),
      key: "agingDays",
    },
    {
      title: this.L("NumOfItem"),
      key: "numOfItem",
    },
    {
      title: this.L("QtySku"),
      key: "qtySku",
    },
  ];

  columnAllocatedPaObjects = [
    {
      title: this.L("Code"),
      key: "code",
      fixed: "left",
    },
    {
      title: this.L("ExternalCode"),
      key: "externalCode",
    },
    {
      title: this.L("Client"),
      key: "clientName",
    },
    {
      title: this.L("Status"),
      key: "textStatus",
    },
    {
      title: this.L("AgingDay"),
      key: "agingDays",
    },
    {
      title: this.L("NumOfItem"),
      key: "numOfItem",
    },
    {
      title: this.L("QtySku"),
      key: "qtySku",
    },
  ];

  get pickWaveTypes() {
    var re = [
      {
        code: "PTO",
        description: "Pick to order",
      },
      {
        code: "STD",
        description: "Standard",
      },
    ];
    this.pickWaveType = re[0].code;
    return re;
  }

  createPickList() {
    if (
      this.isStandard &&
      ((this.numFaObjectSingle > 0 && this.inputNumOfSio == 0) ||
        (this.numFaObjectMutilple > 0 && this.inputNumOfMio == 0))
    ) {
      this.showWraningMsg(Util.L("Error.PwRequireToInputConfigNumberSoPerPw"));
      return;
    }

    let param = {
      pickWaveType: this.isPto ? "PTO" : "STD",
      numOfSio: this.inputNumOfSio,
      numOfMio: this.inputNumOfMio,
      numPlOfSo: this.inputNumPlOfSo,
    };
    this.isCreatingPicklist = true;
    this.$store
      .dispatch("pickwaveCreated/CreatePickList", param)
      .then((res) => {
        this.isCreatingPicklist = false;
        this.step++;
        if (res.pls != null) {
          this.pickLists = res.pls;
          this.numOfPl = res.numOfPl;
        } else {
          this.numFaObjectSingle = 0;
          this.numFaObjectMutilple = 0;
          this.numFaObjectOversize = 0;
        }

        if (res.warningMessage != "") {
          this.showWraningMsg(res.warningMessage);
        }
      })
      .catch(() => {
        this.isCreatingPicklist = false;
      });
  }

  cancelPickWave() {
    this.$store.dispatch("pickwaveCreated/CancelToCreatePickwave").then(() => {
      this.showSuccessMsg(this.L("PickwaveWasCancelledSuccess"));
      this.refreshPage();
    });
  }

  onLoadDefaultGuessStepThree() {
    this.onDetectPwAndTransportPto();
    this.onDetectPwAndTransportSio();
    this.onDetectPwAndTransportMio();
  }

  onChangeRadioPto() {
    if (this.isPto) {
      this.isStandard = false;
      this.onLoadDefaultGuessStepThree();
    }
  }

  onChangeRadioStandard() {
    if (this.isStandard) {
      this.isPto = false;
      this.onLoadDefaultGuessStepThree();
    }
  }

  onDetectPwAndTransportPto() {
    this.strGuessPwPtoAndTransport = "";
    if (this.isPto) {
      this.strGuessPwPtoAndTransport = `Có ${
        this.allocatedFaObjects.length
      } đợt lấy hàng | 1 đợt - 1 rổ`;
    }
  }

  onChangeInputNumberSio() {
    this.onDetectPwAndTransportSio();
  }

  onDetectPwAndTransportSio() {
    this.strGuessPwSioAndTransport = "";
    if (
      this.isStandard &&
      this.inputNumOfSio > 0 &&
      this.numFaObjectSingle > 0
    ) {
      let numPl = Math.floor(this.numFaObjectSingle / this.inputNumOfSio);
      let numPlRemain = this.numFaObjectSingle % this.inputNumOfSio;
      numPl = numPlRemain > 0 ? numPl + 1 : numPl;
      this.strGuessPwSioAndTransport = `Có ${numPl} đợt lấy hàng | 1 đợt - 1 rổ`;
    }
  }

  onChangeInputNumberMio() {
    this.onDetectPwAndTransportMio();
  }

  onDetectPwAndTransportMio() {
    this.strGuessPwMioAndTransport = "";
    if (
      this.isStandard &&
      this.inputNumOfMio > 0 &&
      this.numFaObjectMutilple > 0
    ) {
      let numPl = Math.floor(this.numFaObjectMutilple / this.inputNumOfMio);
      let numPlRemain = this.numFaObjectMutilple % this.inputNumOfMio;
      if (numPl === 0) {
        this.strGuessPwMioAndTransport = `Có 1 đợt lấy hàng | 1 đợt - ${
          this.numFaObjectMutilple
        } rổ`;
      } else if (numPlRemain === 0) {
        this.strGuessPwMioAndTransport = `Có ${numPl} đợt lấy hàng | ${numPl} đợt - ${
          this.inputNumOfMio
        } rổ`;
      } else {
        this.strGuessPwMioAndTransport = `Có ${numPl +
          1} đợt lấy hàng | ${numPl} đợt - ${
          this.inputNumOfMio
        } rổ, 1 đợt - ${numPlRemain} rổ`;
      }
    }
  }

  //=========================================================
  //Step 4 View PickList of PickWave
  columnPickLists = [
    {
      title: this.L("Code"),
      key: "code",
    },
    {
      title: this.L("NumOfObject"),
      key: "numOfObject",
    },
    {
      title: this.L("NumOfItem"),
      key: "numOfItem",
    },
    {
      title: this.L("PickListType"),
      key: "textType",
    },
  ];

  //=========================================================
  //Created after load page
  async created() {
    this.checkWorkOrder();
    // await this.$store.dispatch({
    //     type:'ref/getRefTypesForSelect'
    // });
    await this.$store.dispatch({
      type: "client/getListForSelect",
    });

    await this.$store
      .dispatch({
        type: "saleOrder/getSoStatusesForSelect",
      })
      .then(() => {
        this.soStatuses = this.$store.state.saleOrder.soStatuses;
        this.soStatuses = _.filter(this.soStatuses, (v) =>
          _.includes(AppConsts.soStatusCreatePw, v.code)
        );
        this.$set(
          this.pagerequest,
          "status",
          this.soStatuses.length === 0 ? "" : this.soStatuses[0].code
        );
      });
    this.getRefTypes();
    this.getClients();
    var defaultDate = new Date();
    var fromMoment = moment().subtract(7, "d");
    var fromDate = new Date(fromMoment.format());
    this.soDates = [fromDate, defaultDate];
  }

  refreshPage() {
    this.pagerequest = new PageSearchObjectRequest();
    this.step = 0;
    this.pickWaveId = 0;
    this.pickWave = new PickWave();

    this.list = new Array<PackWaveObject>();
    this.selectedObjects = new Array<PickWaveObject>();

    this.allocatedFaObjects = new Array<PickWaveObject>();
    this.allocatedPaObjects = new Array<PickWaveObject>();
    this.numFaObjectSingle = 0;
    this.numFaObjectMutilple = 0;
    this.numFaObjectOversize = 0;
    this.canCancelPw = false;

    this.pickLists = new Array<PickList>();
    this.numOfPl = 0;
    //this.getRefTypes();
    this.getClients();
    var defaultDate = new Date();
    var fromMoment = moment().subtract(7, "d");
    var fromDate = new Date(fromMoment.format());
    this.soDates = [fromDate, defaultDate];
  }

  onGoBack() {
    this.$root.$router.push({ name: "pick-list" });
  }

  showSuccessMsg(msg: string) {
    Util.showSuccessMsg(this, msg);
  }

  showErrorMsg(msg: string) {
    Util.showErrorMsg(this, msg);
  }

  showWraningMsg(msg: string) {
    Util.showWarningMsg(this, msg);
  }

  //=========================================================
}
